


























import {Component, Emit, Prop, Vue} from 'vue-property-decorator'
import {ExplorerCollection} from '@/model/collection/ExplorerCollection'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'

@Component
export default class FilterExplorerFiltered extends Vue {
  @Prop({type: Object, required: true}) collection!: ExplorerCollection
  @Prop({type: String}) showOnly!: string

  get hasFilteredItems() {
    return this.blockchainVersions?.length
  }

  get blockchainVersions() {
    return this.collection.explorerBlockchainVersion
  }

  @Emit('filter')
  clearBlockchainVersion(blockchainVersion: BlockchainVersion) {
    const {explorerBlockchainVersion} = this.collection
    this.collection.explorerBlockchainVersion =
      explorerBlockchainVersion?.filter(
        item => item.$id !== blockchainVersion.$id
      ) || []
  }

  @Emit('filter')
  doClear() {
    this.collection.explorerBlockchainVersion = []
  }
}
